import "../css/nav.css"

function FooterComp(){
    return(
        <div className="footerCont">
            <p>© McCanna Law, PLLC & James K. McCanna. All rights reserved.</p>
        </div>
    )
}
export default FooterComp;